import { Component, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiService } from 'src/app/Services/api.service';

@Component({
    selector: 'app-edit-officer',
    templateUrl: './edit-officer.component.html',
    styleUrls: ['./edit-officer.component.scss'],
    standalone: false
})
export class EditOfficerComponent extends ModelEditor {

  public userCreationMode: 'existing' | 'new' = 'existing';
  public selectedUser: any = null;

  constructor(
    private apiService: ApiService,
    public route: ActivatedRoute,
    private injector: Injector,
    private toastr: ToastrService
  ) {
    super('enforcement/officers', injector);
  }

  public DefaultModel() {
    return {
      CreateNewUser: false,
      UserId: null,  // Use null instead of empty string so selector shows empty state
      Email: '',
      FirstName: '',
      LastName: '',
      BadgeNumber: '',
      IsActive: true,
      Notes: ''
    };
  }

  public AfterModelLoaded(): void {
  }

  public BeforeSave(): boolean | void {
    if (this.isNewRecord()) {
      // Set the creation mode in the form
      this.Form.get('CreateNewUser')?.setValue(this.userCreationMode === 'new');
      
      if (this.userCreationMode === 'existing') {
        // Check form control value, not Model (form control is updated by ControlValueAccessor)
        const userId = this.Form.get('UserId')?.value;
        if (!userId) {
          this.toastr.error('Please select an existing user');
          return false;
        }
        // Clear new user fields when saving in existing mode
        this.Form.get('Email')?.setValue(null);
        this.Form.get('FirstName')?.setValue(null);
        this.Form.get('LastName')?.setValue(null);
      } else {
        // Check form control values for new user fields
        const email = this.Form.get('Email')?.value;
        const firstName = this.Form.get('FirstName')?.value;
        const lastName = this.Form.get('LastName')?.value;
        
        if (!email || !firstName || !lastName) {
          this.toastr.error('Please fill in all required fields for the new user');
          return false;
        }
        // Clear UserId when saving in new user mode
        this.Form.get('UserId')?.setValue(null);
      }
    }
    return true;
  }

  // Don't use reactive form validation - we handle it manually in BeforeSave
  public Validators() {
    return {};
  }

  public isNewRecord(): boolean {
    return this.ModelId === 'new';
  }

  public onUserSelected(user: any) {
    // The user object from userselector contains Id, FirstName, LastName, Email
    if (user && user.Id) {
      this.selectedUser = user;
      // Form control is already updated by ControlValueAccessor, but sync Model for display
      this.Model.UserId = user.Id;
    }
  }

  public onUserCleared() {
    this.selectedUser = null;
    this.Model.UserId = null;
    // Form control is already updated by ControlValueAccessor
  }

  public onUserCreationModeChange() {
    // Reset fields when switching modes
    if (this.userCreationMode === 'new') {
      this.selectedUser = null;
      this.Form.get('UserId')?.setValue(null);
    } else {
      this.Form.get('Email')?.setValue('');
      this.Form.get('FirstName')?.setValue('');
      this.Form.get('LastName')?.setValue('');
    }
  }
}


